import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTORechtsgrundlagenListStatus: 'idle',
    loadTORechtsgrundlagenListError: undefined as any,
    loadTORechtsgrundlagenListLastArgs: undefined as any,
    loadTORechtsgrundlagenStatus: 'idle',
    loadTORechtsgrundlagenError: undefined as any,
    saveTORechtsgrundlagenStatus: 'idle',
    saveTORechtsgrundlagenError: undefined as any,
    deleteTORechtsgrundlagenStatus: 'idle',
    deleteTORechtsgrundlagenError: undefined as any,

    tORechtsgrundlagenList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTORechtsgrundlagenList = createAsyncThunk('toRechtsgrundlagenSlice/loadTORechtsgrundlagenList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toRechtsgrundlagenSlice.loadTORechtsgrundlagenListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristotorechtsgrundlagen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTORechtsgrundlagenListStatus } = getState().toRechtsgrundlagenSlice
        return loadTORechtsgrundlagenListStatus !== 'pending'
    }
})

export const loadTORechtsgrundlagen = createAsyncThunk('toRechtsgrundlagenSlice/loadTORechtsgrundlagen', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristotorechtsgrundlagen/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTORechtsgrundlagenStatus } = getState().toRechtsgrundlagenSlice
        return loadTORechtsgrundlagenStatus !== 'pending'
    }
})

export const saveTORechtsgrundlagen = createAsyncThunk('toRechtsgrundlagenSlice/saveTORechtsgrundlagen', async ({ tORechtsgrundlagen }: any, { rejectWithValue }: any) => {
    let promises = []
    if (tORechtsgrundlagen?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristotorechtsgrundlagen/${ tORechtsgrundlagen?.HDR_ID }/`,
            prepareData(tORechtsgrundlagen),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristotorechtsgrundlagen/`,
            prepareData(tORechtsgrundlagen),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTORechtsgrundlagenStatus } = getState().toRechtsgrundlagenSlice
        return saveTORechtsgrundlagenStatus !== 'pending'
    }
})

export const deleteTORechtsgrundlagen = createAsyncThunk('toRechtsgrundlagenSlice/deleteTORechtsgrundlagen', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteTORechtsgrundlagen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTORechtsgrundlagenStatus } = getState().toRechtsgrundlagenSlice
        return deleteTORechtsgrundlagenStatus !== 'pending'
    }
})

const TORechtsgrundlagenSlice = createSlice({
    name: 'toRechtsgrundlagenSlice',
    initialState,
    reducers: {
        resetloadTORechtsgrundlagenListError: (state) => {
            state.loadTORechtsgrundlagenListError = undefined
        },
        resetloadTORechtsgrundlagen: (state) => {
            state.formItem = undefined
            state.loadTORechtsgrundlagenError = undefined
        },
        resetloadTORechtsgrundlagenError: (state) => {
            state.loadTORechtsgrundlagenError = undefined
        },
        resetsaveTORechtsgrundlagen: (state) => {
            state.formItem = undefined
            state.saveTORechtsgrundlagenError = undefined
        },
        resetsaveTORechtsgrundlagenError: (state) => {
            state.saveTORechtsgrundlagenError = undefined
        },
        resetdeleteTORechtsgrundlagenError: (state) => {
            state.deleteTORechtsgrundlagenError = undefined
        },
        removeFromTORechtsgrundlagenListById: (state, action) => {
            state.tORechtsgrundlagenList = state.tORechtsgrundlagenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTORechtsgrundlagenListByIds: (state, action) => {
            state.tORechtsgrundlagenList = state.tORechtsgrundlagenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tORechtsgrundlagenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTORechtsgrundlagenListStatus = 'preloaded'
            state.loadTORechtsgrundlagenListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tORechtsgrundlagenList = []
            state.loadTORechtsgrundlagenListStatus = 'idle'
            state.loadTORechtsgrundlagenListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTORechtsgrundlagenList.pending, (state) => {
            state.loadTORechtsgrundlagenListStatus = 'pending'
            state.loadTORechtsgrundlagenListError = undefined
        })
        builder.addCase(loadTORechtsgrundlagenList.fulfilled, (state, action) => {
            state.loadTORechtsgrundlagenListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTORechtsgrundlagenListLastArgs = action.payload.args

            {
                state.tORechtsgrundlagenList = action.payload.data

            }
        })
        builder.addCase(loadTORechtsgrundlagenList.rejected, (state, action) => {
            state.loadTORechtsgrundlagenListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTORechtsgrundlagenListError = action.error.message
            } else {
                state.loadTORechtsgrundlagenListError = action.payload
            }
        })

        builder.addCase(loadTORechtsgrundlagen.pending, (state) => {
            state.loadTORechtsgrundlagenStatus = 'pending'
            state.loadTORechtsgrundlagenError = undefined
        })
        builder.addCase(loadTORechtsgrundlagen.fulfilled, (state, action) => {
            state.loadTORechtsgrundlagenStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tORechtsgrundlagenList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tORechtsgrundlagenList.push(newItem) }
                else { state.tORechtsgrundlagenList[i] = { ...state.tORechtsgrundlagenList[i], ...newItem } }
            }
        })
        builder.addCase(loadTORechtsgrundlagen.rejected, (state, action) => {
            state.loadTORechtsgrundlagenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTORechtsgrundlagenError = action.error.message
            } else {
                state.loadTORechtsgrundlagenError = action.payload
            }
        })

        builder.addCase(saveTORechtsgrundlagen.pending, (state) => {
            state.saveTORechtsgrundlagenStatus = 'pending'
            state.saveTORechtsgrundlagenError = undefined
        })
        builder.addCase(saveTORechtsgrundlagen.fulfilled, (state, action) => {
            state.saveTORechtsgrundlagenStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tORechtsgrundlagenList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tORechtsgrundlagenList.push(newItem) }
                else { state.tORechtsgrundlagenList[i] = { ...state.tORechtsgrundlagenList[i], ...newItem } }
            }
        })
        builder.addCase(saveTORechtsgrundlagen.rejected, (state, action) => {
            state.saveTORechtsgrundlagenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTORechtsgrundlagenError = action.error.message
            } else {
                state.saveTORechtsgrundlagenError = action.payload
            }
        })

        builder.addCase(deleteTORechtsgrundlagen.pending, (state) => {
            state.deleteTORechtsgrundlagenStatus = 'pending'
            state.deleteTORechtsgrundlagenError = undefined
        })
        builder.addCase(deleteTORechtsgrundlagen.fulfilled, (state, action) => {
            state.deleteTORechtsgrundlagenStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tORechtsgrundlagenList = state.tORechtsgrundlagenList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tORechtsgrundlagenList = state.tORechtsgrundlagenList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTORechtsgrundlagen.rejected, (state, action) => {
            state.deleteTORechtsgrundlagenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTORechtsgrundlagenError = action.error.message
            } else {
                state.deleteTORechtsgrundlagenError = action.payload
            }
        })

    }
})

export const {
    resetloadTORechtsgrundlagenListError,
    resetloadTORechtsgrundlagen,
    resetloadTORechtsgrundlagenError,
    resetsaveTORechtsgrundlagen,
    resetsaveTORechtsgrundlagenError,
    resetdeleteTORechtsgrundlagenError,
    removeFromTORechtsgrundlagenListById,
    removeFromTORechtsgrundlagenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TORechtsgrundlagenSlice.actions
export default TORechtsgrundlagenSlice.reducer
